(() => {
  const moneyText = (value) => value || '';
  const customerId = document.body.dataset.customerId || '';
  const accountLoginUrl = document.body.dataset.accountLoginUrl || '/account/login';
  const wishlistKey = customerId ? `luxoraboutiqueWishlist:${customerId}` : '';

  const redirectToLogin = () => {
    window.location.assign(accountLoginUrl);
  };

  const readWishlist = () => {
    if (!wishlistKey) return [];
    try {
      const saved = JSON.parse(window.localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(saved) ? saved.filter((item) => item && item.handle) : [];
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    if (!wishlistKey) return;
    try {
      window.localStorage.setItem(wishlistKey, JSON.stringify(items));
    } catch (error) {
      // De shop blijft bruikbaar wanneer browseropslag is uitgeschakeld.
    }
  };

  const productFromButton = (button) => ({
    handle: button.dataset.productHandle || '',
    title: button.dataset.productTitle || '',
    url: button.dataset.productUrl || '#',
    price: button.dataset.productPrice || '',
    image: button.dataset.productImage || ''
  });

  const updateWishlistControls = () => {
    const wishlist = readWishlist();
    const handles = new Set(wishlist.map((item) => item.handle));

    document.querySelectorAll('[data-wishlist-count]').forEach((node) => {
      node.textContent = String(wishlist.length);
    });

    document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
      const active = handles.has(button.dataset.productHandle || '');
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.title = active ? 'Verwijder uit verlanglijst' : 'Zet op verlanglijst';

      const icon = button.querySelector('.wishlist-button__icon');
      if (icon) icon.textContent = active ? '♥' : '♡';

      const text = button.querySelector('[data-wishlist-text]');
      if (text) text.textContent = active ? 'Verwijder uit mijn verlanglijst' : 'Zet op mijn verlanglijst';

      const title = button.dataset.productTitle || 'dit product';
      button.setAttribute(
        'aria-label',
        active ? `Verwijder ${title} uit je verlanglijst` : `Zet ${title} op je verlanglijst`
      );
    });
  };

  const toggleWishlistItem = (button) => {
    if (!customerId) {
      redirectToLogin();
      return;
    }

    const product = productFromButton(button);
    if (!product.handle) return;

    const wishlist = readWishlist();
    const index = wishlist.findIndex((item) => item.handle === product.handle);
    if (index >= 0) {
      wishlist.splice(index, 1);
    } else {
      wishlist.unshift(product);
    }
    writeWishlist(wishlist);
    updateWishlistControls();
    renderWishlistPage();
  };

  const safeLink = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return '#';
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      return '#';
    }
  };

  const safeImage = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
      return url.href;
    } catch (error) {
      return '';
    }
  };

  const createWishlistCard = (product) => {
    const article = document.createElement('article');
    article.className = 'wishlist-card';

    const imageLink = document.createElement('a');
    imageLink.className = 'wishlist-card__image';
    imageLink.href = safeLink(product.url);
    imageLink.setAttribute('aria-label', `Bekijk ${product.title || 'product'}`);

    const imageUrl = safeImage(product.image);
    if (imageUrl) {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = product.title || '';
      image.loading = 'lazy';
      imageLink.appendChild(image);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'wishlist-card__placeholder';
      placeholder.textContent = 'Geen afbeelding';
      imageLink.appendChild(placeholder);
    }

    const body = document.createElement('div');
    body.className = 'wishlist-card__body';

    const title = document.createElement('h2');
    const titleLink = document.createElement('a');
    titleLink.href = safeLink(product.url);
    titleLink.textContent = product.title || 'Product';
    title.appendChild(titleLink);

    const price = document.createElement('p');
    price.className = 'wishlist-card__price';
    price.textContent = product.price || '';

    const actions = document.createElement('div');
    actions.className = 'wishlist-card__actions';

    const view = document.createElement('a');
    view.className = 'button button--small';
    view.href = safeLink(product.url);
    view.textContent = 'Bekijk product';

    const remove = document.createElement('button');
    remove.className = 'wishlist-remove';
    remove.type = 'button';
    remove.dataset.wishlistRemove = product.handle;
    remove.textContent = 'Verwijderen';

    actions.append(view, remove);
    body.append(title, price, actions);
    article.append(imageLink, body);
    return article;
  };

  const renderWishlistPage = () => {
    const grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    const wishlist = readWishlist();
    const empty = document.querySelector('[data-wishlist-empty]');
    grid.replaceChildren(...wishlist.map(createWishlistCard));
    if (empty) empty.hidden = wishlist.length !== 0;
  };

  document.addEventListener('click', (event) => {
    const wishlistButton = event.target.closest('[data-wishlist-button]');
    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlistItem(wishlistButton);
      return;
    }

    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      if (!customerId) {
        redirectToLogin();
        return;
      }
      const handle = removeButton.dataset.wishlistRemove;
      const wishlist = readWishlist().filter((item) => item.handle !== handle);
      writeWishlist(wishlist);
      updateWishlistControls();
      renderWishlistPage();
    }
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantSelect = section.querySelector('[data-variant-select]');
    const variantInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-compare-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addText = section.querySelector('[data-add-button-text]');
    const json = section.querySelector('[data-product-variants]');
    const variants = json ? JSON.parse(json.textContent).variants : [];

    const showMedia = (mediaId) => {
      if (!mediaId) return;
      section.querySelectorAll('[data-media-id]').forEach((media) => {
        const active = Number(media.dataset.mediaId) === Number(mediaId);
        media.classList.toggle('is-active', active);
        if (!active) media.querySelectorAll('video').forEach((video) => video.pause());
      });
      section.querySelectorAll('[data-media-target]').forEach((thumb) => {
        thumb.classList.toggle('is-active', Number(thumb.dataset.mediaTarget) === Number(mediaId));
      });
    };

    section.querySelectorAll('[data-media-target]').forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaTarget));
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const variant = variants.find((item) => Number(item.id) === Number(variantSelect.value));
        if (!variant) return;
        variantInput.value = variant.id;
        price.textContent = moneyText(variant.price);
        if (variant.compare_at_price) {
          compare.textContent = variant.compare_at_price;
          compare.hidden = false;
        } else {
          compare.hidden = true;
          compare.textContent = '';
        }
        addButton.disabled = !variant.available;
        addText.textContent = variant.available ? 'Aan winkelwagen toevoegen' : 'Uitverkocht';
        showMedia(variant.featured_media_id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      });
    }

    section.querySelectorAll('[data-tab-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const tab = button.dataset.tabButton;
        section.querySelectorAll('[data-tab-button]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        section.querySelectorAll('[data-tab-panel]').forEach((panel) => panel.classList.toggle('is-active', panel.dataset.tabPanel === tab));
      });
    });
  });


  document.querySelectorAll('[data-print-invoice]').forEach((button) => {
    button.addEventListener('click', () => window.print());
  });

  window.LuxorWishlistRefresh = updateWishlistControls;
  updateWishlistControls();
  renderWishlistPage();
})();

/* Uitklapbare FAQ-pagina's */
(() => {
  const directElementChildren = (container) => Array.from(container.children || []);

  const isQuestionNode = (node) => {
    if (!(node instanceof HTMLElement)) return false;
    if (/^H[2-4]$/.test(node.tagName)) return true;

    if (node.tagName === 'P') {
      const meaningfulChildren = Array.from(node.children).filter((child) => !['BR'].includes(child.tagName));
      const first = meaningfulChildren[0];
      const onlyEmphasis = meaningfulChildren.length === 1 && first && ['STRONG', 'B'].includes(first.tagName);
      return onlyEmphasis && node.textContent.trim().length > 0;
    }

    return node.classList.contains('faq-question');
  };

  const questionHtml = (node) => {
    if (node.tagName === 'P' && node.children.length === 1) {
      return node.firstElementChild ? node.firstElementChild.innerHTML : node.innerHTML;
    }
    return node.innerHTML;
  };

  const initFaq = (scope = document) => {
    scope.querySelectorAll('[data-faq-page]').forEach((page) => {
      if (page.dataset.faqReady === 'true') return;

      const source = page.querySelector('[data-faq-source]');
      const accordion = page.querySelector('[data-faq-accordion]');
      if (!source || !accordion) return;

      const nodes = directElementChildren(source);
      const introNodes = [];
      const groups = [];
      let currentGroup = null;

      nodes.forEach((node) => {
        if (isQuestionNode(node)) {
          currentGroup = { question: node, answers: [] };
          groups.push(currentGroup);
        } else if (currentGroup) {
          currentGroup.answers.push(node);
        } else {
          introNodes.push(node);
        }
      });

      if (!groups.length) return;

      accordion.replaceChildren();
      if (introNodes.length) {
        const intro = document.createElement('div');
        intro.className = 'faq-page__intro rte';
        intro.append(...introNodes.map((node) => node.cloneNode(true)));
        accordion.appendChild(intro);
      }

      const iconStyle = page.dataset.faqIcon === 'arrow' ? 'arrow' : 'plus';
      const openFirst = page.dataset.faqOpenFirst === 'true';
      const singleOpen = page.dataset.faqSingleOpen !== 'false';

      groups.forEach((group, index) => {
        const details = document.createElement('details');
        details.className = `faq-item faq-item--${iconStyle}`;
        if (openFirst && index === 0) details.open = true;

        const summary = document.createElement('summary');
        summary.className = 'faq-item__question';

        const label = document.createElement('span');
        label.className = 'faq-item__label';
        label.innerHTML = questionHtml(group.question);

        const icon = document.createElement('span');
        icon.className = 'faq-item__icon';
        icon.setAttribute('aria-hidden', 'true');
        summary.append(label, icon);

        const answer = document.createElement('div');
        answer.className = 'faq-item__answer rte';
        if (group.answers.length) answer.append(...group.answers.map((node) => node.cloneNode(true)));

        details.append(summary, answer);
        accordion.appendChild(details);

        if (singleOpen) {
          details.addEventListener('toggle', () => {
            if (!details.open) return;
            accordion.querySelectorAll('.faq-item[open]').forEach((other) => {
              if (other !== details) other.open = false;
            });
          });
        }
      });

      source.hidden = true;
      accordion.hidden = false;
      page.dataset.faqReady = 'true';
    });
  };

  window.LuxorInitFaq = initFaq;
  initFaq(document);
})();

/* Ingebouwde catalogusfilters zonder extra Shopify-app */
(() => {
  const normalize = (value) => String(value || '')
    .trim()
    .toLocaleLowerCase('nl-NL')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/^badge\s*:\s*/, '')
    .replace(/^badge\s+/, '')
    .replace(/\s+/g, ' ')
    .replace(/(\d)\s*(ml|cl|gram|g|l)\b/gi, '$1 $2');

  const compactValue = (value) => normalize(value).replace(/[^a-z0-9]/g, '');

  const splitValues = (value) => String(value || '')
    .split('||')
    .map(normalize)
    .filter(Boolean);

  const numberValue = (input) => {
    let raw = String(input?.value || '').trim();
    if (!raw) return null;

    // Accepteert Nederlandse én internationale prijsnotatie, bijvoorbeeld
    // 27,95 / 27.95 / € 1.299,95 / 1,299.95.
    raw = raw.replace(/\s+/g, '').replace(/[^0-9,.-]/g, '');
    if (!raw) return null;

    const commaIndex = raw.lastIndexOf(',');
    const dotIndex = raw.lastIndexOf('.');
    if (commaIndex !== -1 && dotIndex !== -1) {
      if (commaIndex > dotIndex) {
        raw = raw.replace(/\./g, '').replace(',', '.');
      } else {
        raw = raw.replace(/,/g, '');
      }
    } else if (commaIndex !== -1) {
      raw = raw.replace(',', '.');
    }

    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
  };

  const initCatalog = async (root) => {
    const grid = root.querySelector('[data-catalog-grid]');
    const filterForm = root.querySelector('[data-catalog-filter-form]');
    if (!grid || !filterForm) return;

    const sectionId = root.dataset.sectionId;
    const totalPages = Math.max(1, Number(root.dataset.totalPages || 1));
    const currentPage = Math.max(1, Number(root.dataset.currentPage || 1));
    const filters = root.querySelector('[data-catalog-filters]');
    const overlay = root.querySelector('[data-catalog-filter-overlay]');
    const openButton = root.querySelector('[data-catalog-filter-open]');
    const countBadges = root.querySelectorAll('[data-catalog-active-count]');
    const visibleCountNodes = root.querySelectorAll('[data-catalog-visible-count]');
    const resultWord = root.querySelector('[data-catalog-result-word]');
    const noResults = root.querySelector('[data-catalog-no-results]');
    const sortSelect = root.querySelector('[data-catalog-sort]');
    const groupParamNames = {
      category: 'lb_category',
      audience: 'lb_audience',
      scent: 'lb_scent',
      size: 'lb_size'
    };

    const setDrawer = (open) => {
      filters?.classList.toggle('is-open', open);
      overlay?.classList.toggle('is-visible', open);
      document.body.classList.toggle('catalog-filters-open', open);
      openButton?.setAttribute('aria-expanded', open ? 'true' : 'false');
      filters?.setAttribute('aria-hidden', open ? 'false' : 'true');
    };

    openButton?.addEventListener('click', () => setDrawer(true));
    root.querySelectorAll('[data-catalog-filter-close]').forEach((button) => {
      button.addEventListener('click', () => setDrawer(false));
    });
    overlay?.addEventListener('click', () => setDrawer(false));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && filters?.classList.contains('is-open')) setDrawer(false);
    });

    const restoreStateFromUrl = () => {
      const params = new URLSearchParams(window.location.search);
      Object.entries(groupParamNames).forEach(([group, paramName]) => {
        const selected = new Set(params.getAll(paramName).map(normalize));
        filterForm.querySelectorAll(`[data-filter-group="${group}"]`).forEach((input) => {
          input.checked = selected.has(normalize(input.value));
        });
      });
      const minInput = filterForm.querySelector('[data-filter-price-min]');
      const maxInput = filterForm.querySelector('[data-filter-price-max]');
      if (minInput && params.has('lb_min')) minInput.value = params.get('lb_min');
      if (maxInput && params.has('lb_max')) maxInput.value = params.get('lb_max');
    };

    const writeStateToUrl = () => {
      const url = new URL(window.location.href);
      Object.values(groupParamNames).forEach((paramName) => url.searchParams.delete(paramName));
      // Oude filterparameters uit eerdere themaversies opruimen.
      url.searchParams.delete('lb_status');
      url.searchParams.delete('lb_feature');
      Object.entries(groupParamNames).forEach(([group, paramName]) => {
        filterForm.querySelectorAll(`[data-filter-group="${group}"]:checked`).forEach((input) => {
          url.searchParams.append(paramName, input.value);
        });
      });
      const min = numberValue(filterForm.querySelector('[data-filter-price-min]'));
      const max = numberValue(filterForm.querySelector('[data-filter-price-max]'));
      if (min === null) url.searchParams.delete('lb_min'); else url.searchParams.set('lb_min', String(min));
      if (max === null) url.searchParams.delete('lb_max'); else url.searchParams.set('lb_max', String(max));
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    };

    const fetchAdditionalPages = async () => {
      if (!sectionId || totalPages <= 1) return;

      const requests = [];
      for (let page = 1; page <= totalPages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        url.searchParams.set('page', String(page));
        requests.push(
          fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then((response) => {
              if (!response.ok) throw new Error(`Pagina ${page} kon niet worden geladen`);
              return response.text();
            })
        );
      }

      try {
        const pages = await Promise.all(requests);
        pages.forEach((html) => {
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          documentFragment.querySelectorAll('[data-catalog-product]').forEach((card) => {
            grid.appendChild(document.importNode(card, true));
          });
        });
      } catch (error) {
        // Bij een netwerkfout blijft de gewone Shopify-paginering beschikbaar.
        root.classList.remove('is-enhanced');
      } finally {
        window.LuxorWishlistRefresh?.();
      }
    };

    const selectedValues = (group) => Array.from(filterForm.querySelectorAll(`[data-filter-group="${group}"]:checked`))
      .map((input) => normalize(input.value));

    const cardData = (card) => {
      const tags = splitValues(card.dataset.filterTags);
      const collections = splitValues(card.dataset.filterCollections);
      const options = splitValues(card.dataset.filterOptions);
      const productType = normalize(card.dataset.filterType);
      const title = normalize(card.dataset.filterTitle);
      return {
        tags,
        collections,
        options,
        productType,
        title,
        price: Number(card.dataset.filterPrice || 0) / 100
      };
    };

    const includesAny = (haystack, needles) => needles.length === 0 || needles.some((needle) => haystack.includes(needle));

    const escapeRegExp = (value) => String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    // Controleert een volledig woord of een volledige woordgroep. Hierdoor telt "male"
    // niet mee in "female" en telt het algemene woord "parfum" niet als herenparfum.
    const containsWholePhrase = (candidate, phrase) => {
      const text = normalize(candidate);
      const wanted = normalize(phrase);
      if (!text || !wanted) return false;
      const pattern = new RegExp(`(^|[^a-z0-9])${escapeRegExp(wanted).replace(/\\ /g, '\\s+')}($|[^a-z0-9])`, 'i');
      return pattern.test(text);
    };

    const matchesAliases = (haystack, aliases) => haystack.some((item) =>
      aliases.some((alias) => containsWholePhrase(item, alias))
    );

    const categoryAliases = {
      damesparfums: [
        'damesparfum', 'damesparfums', 'dames parfum', 'dames parfums', 'parfum dames',
        'vrouwengeur', 'vrouwengeuren', 'vrouwenparfum', 'vrouwenparfums', 'vrouwelijke geur',
        'vrouwelijke geuren', 'women fragrance', 'women fragrances', 'womens fragrance',
        'womens fragrances', 'female fragrance', 'female fragrances', 'for women'
      ],
      herenparfums: [
        'herenparfum', 'herenparfums', 'heren parfum', 'heren parfums', 'parfum heren',
        'herengeur', 'herengeuren', 'mannenparfum', 'mannenparfums', 'mannelijke geur',
        'mannelijke geuren', 'men fragrance', 'men fragrances', 'mens fragrance',
        'mens fragrances', 'male fragrance', 'male fragrances', 'for men'
      ],
      beauty: [
        'beauty', 'make-up', 'makeup', 'make up', 'colour cosmetics', 'color cosmetics',
        'decorative cosmetics', 'decoratieve cosmetica'
      ],
      'luxora evoira': [
        'luxora evoira', 'luxora-evoira', 'luxora évoira', 'evoira', 'évoira',
        'luxe cosmeticacollectie', 'luxury cosmetics'
      ],
      verzorging: [
        'verzorging', 'persoonlijke verzorging', 'beauty & skin care', 'beauty and skin care',
        'skin care', 'skincare', 'lichaamsverzorging', 'body care', 'personal care',
        'face care', 'facial care', 'hair care'
      ],
      wellness: [
        'wellness', 'food supplements', 'food supplement', 'voedingssupplementen',
        'voedingssupplement', 'supplementen', 'supplement'
      ],
      'nieuwe producten': [
        'nieuwe producten', 'nieuw product', 'new products', 'new product',
        'new arrivals', 'nieuw binnen', 'net binnen'
      ],
      'koffie & thee': [
        'koffie & thee', 'koffie en thee', 'koffie-thee', 'coffee & tea',
        'coffee and tea', 'coffee tea'
      ],
      'voor thuis': [
        'voor thuis', 'for home', 'home products', 'home product', 'huishouden',
        'huishoudelijk', 'woonaccessoires'
      ],
      accessoires: ['accessoire', 'accessoires', 'accessory', 'accessories']
    };

    const careCategoryAliases = categoryAliases.verzorging;
    const luxoraCategoryAliases = categoryAliases['luxora evoira'];
    const explicitBeautyAliases = ['beauty', 'make-up', 'makeup', 'make up', 'colour cosmetics', 'color cosmetics'];

    const audienceAliases = {
      dames: [
        'dame', 'dames', 'vrouw', 'vrouwen', 'vrouwelijk', 'vrouwelijke', 'woman', 'women',
        'womens', 'female', 'damesparfum', 'damesparfums', 'dames parfum', 'dames parfums',
        'vrouwengeur', 'vrouwengeuren', 'vrouwenparfum', 'vrouwenparfums', 'vrouwelijke geur',
        'female fragrance', 'women fragrance', 'womens fragrance', 'for women'
      ],
      heren: [
        'heer', 'heren', 'man', 'mannen', 'mannelijk', 'mannelijke', 'men', 'mens', 'male',
        'herenparfum', 'herenparfums', 'heren parfum', 'heren parfums', 'herengeur',
        'herengeuren', 'mannenparfum', 'mannenparfums', 'mannelijke geur', 'male fragrance',
        'men fragrance', 'mens fragrance', 'for men'
      ],
      unisex: [
        'unisex', 'genderneutraal', 'gender neutral', 'genderneutral', 'voor iedereen',
        'vooriedereen', 'dames en heren', 'heren en dames', 'women and men', 'men and women'
      ]
    };

    const perfumeAliases = [
      'parfum', 'parfums', 'perfume', 'perfumes', 'fragrance', 'fragrances',
      'eau de parfum', 'eau de toilette', 'edp', 'edt', 'geur', 'geuren'
    ];

    const matchesCategory = (data, category) => {
      const wanted = normalize(category);
      const aliases = categoryAliases[wanted] || [wanted];
      const searchable = [...data.tags, ...data.collections, data.productType, data.title].filter(Boolean);

      // Producten kunnen in Shopify op twee manieren zijn ingedeeld:
      // 1. rechtstreeks als "Damesparfums" / "Herenparfums";
      // 2. apart als "PERFUMES" én "Dames/Women" of "Heren/Men".
      // Beide vormen moeten onder de juiste parfumcategorie verschijnen.
      if (wanted === 'damesparfums' || wanted === 'herenparfums') {
        if (matchesAliases(searchable, aliases)) return true;

        const isPerfume = matchesAliases(searchable, perfumeAliases);
        const isForWomen = matchesAliases(searchable, audienceAliases.dames);
        const isForMen = matchesAliases(searchable, audienceAliases.heren);

        if (wanted === 'damesparfums') return isPerfume && isForWomen && !isForMen;
        return isPerfume && isForMen && !isForWomen;
      }

      // BEAUTY & SKIN CARE hoort onder Verzorging en niet automatisch onder Beauty.
      // Luxora Évoira blijft als eigen cosmeticacollectie gescheiden van Beauty.
      if (wanted === 'beauty') {
        const isCare = matchesAliases(searchable, careCategoryAliases);
        const isLuxora = matchesAliases(searchable, luxoraCategoryAliases);
        const isExplicitBeauty = matchesAliases(searchable, explicitBeautyAliases);
        return isExplicitBeauty && !isCare && !isLuxora;
      }

      return matchesAliases(searchable, aliases);
    };

    const matchesAudience = (data, audience) => {
      const wanted = normalize(audience);
      const aliases = audienceAliases[wanted] || [wanted];
      const searchable = [...data.tags, ...data.collections, data.productType, data.title].filter(Boolean);
      return matchesAliases(searchable, aliases);
    };

    const matchesCard = (card, selections, minPrice, maxPrice) => {
      const data = cardData(card);

      const categoryMatch = selections.category.length === 0 || selections.category.some((value) => matchesCategory(data, value));
      const audienceMatch = selections.audience.length === 0 || selections.audience.some((value) => matchesAudience(data, value));
      const scentMatch = includesAny(data.tags, selections.scent);
      const sizeMatch = selections.size.length === 0 || selections.size.some((value) => {
        if (value === 'andere inhoud') {
          const standard = ['15 ml', '30 ml', '50 ml', '100 ml'];
          const foundSizes = [...data.tags, ...data.options].filter((item) => /\b\d+(?:[.,]\d+)?\s+(?:ml|g|gram|cl|l)\b/i.test(item));
          return foundSizes.some((item) => !standard.includes(item));
        }
        return data.tags.includes(value) || data.options.includes(value);
      });
      const minMatch = minPrice === null || data.price >= minPrice;
      const maxMatch = maxPrice === null || data.price <= maxPrice;

      return categoryMatch && audienceMatch && scentMatch && sizeMatch && minMatch && maxMatch;
    };

    const applyFilters = () => {
      const selections = Object.fromEntries(Object.keys(groupParamNames).map((group) => [group, selectedValues(group)]));
      const minPrice = numberValue(filterForm.querySelector('[data-filter-price-min]'));
      const maxPrice = numberValue(filterForm.querySelector('[data-filter-price-max]'));
      let visible = 0;

      grid.querySelectorAll('[data-catalog-product]').forEach((card) => {
        const matches = matchesCard(card, selections, minPrice, maxPrice);
        card.hidden = !matches;
        if (matches) visible += 1;
      });

      const checkedCount = filterForm.querySelectorAll('[data-filter-group]:checked').length;
      const activeCount = checkedCount + (minPrice !== null ? 1 : 0) + (maxPrice !== null ? 1 : 0);
      countBadges.forEach((badge) => {
        badge.textContent = String(activeCount);
        badge.hidden = activeCount === 0;
      });
      visibleCountNodes.forEach((node) => { node.textContent = String(visible); });
      if (resultWord) resultWord.textContent = visible === 1 ? 'product' : 'producten';
      if (noResults) noResults.hidden = visible !== 0;
      writeStateToUrl();
    };

    let priceTimer;
    filterForm.addEventListener('submit', (event) => {
      event.preventDefault();
      applyFilters();
    });
    filterForm.addEventListener('change', applyFilters);
    filterForm.addEventListener('input', (event) => {
      if (!event.target.matches('[data-filter-price-min], [data-filter-price-max]')) return;
      window.clearTimeout(priceTimer);
      priceTimer = window.setTimeout(applyFilters, 180);
    });

    root.querySelectorAll('[data-catalog-clear]').forEach((button) => {
      button.addEventListener('click', () => {
        filterForm.reset();
        applyFilters();
      });
    });

    sortSelect?.addEventListener('change', () => {
      // Schrijf eerst alle actieve filters naar de URL. Zo blijven categorie,
      // doelgroep, geurfamilie, inhoud en prijs behouden na het sorteren.
      writeStateToUrl();
      const url = new URL(window.location.href);
      if (sortSelect.value === 'default') {
        url.searchParams.delete('sort_by');
      } else {
        url.searchParams.set('sort_by', sortSelect.value);
      }
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });

    restoreStateFromUrl();
    root.classList.add('is-enhanced');
    await fetchAdditionalPages();
    applyFilters();
  };

  document.querySelectorAll('[data-catalog-root]').forEach((root) => initCatalog(root));
})();


/* Footerpagina's in een sluitbare informatie-pop-up */
(() => {
  const modal = document.querySelector('[data-footer-info-modal]');
  if (!modal) return;

  const panel = modal.querySelector('.footer-info-modal__panel');
  const title = modal.querySelector('[data-footer-info-modal-title]');
  const body = modal.querySelector('[data-footer-info-modal-body]');
  const loading = modal.querySelector('[data-footer-info-modal-loading]');
  const cache = new Map();
  let returnFocus = null;
  let requestController = null;

  const setLoading = (isLoading) => {
    loading.hidden = !isLoading;
    body.hidden = isLoading;
  };

  const closeModal = () => {
    requestController?.abort();
    requestController = null;
    modal.hidden = true;
    document.body.classList.remove('footer-info-modal-open');
    body.replaceChildren();
    returnFocus?.focus?.();
  };

  const cleanFetchedContent = (container) => {
    container.querySelectorAll('script, style, link[rel="stylesheet"], noscript').forEach((node) => node.remove());
    container.querySelectorAll('[autofocus]').forEach((node) => node.removeAttribute('autofocus'));
    return container;
  };

  const extractContent = (html) => {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const main = parsed.querySelector('#MainContent');
    if (!main) throw new Error('Pagina-inhoud niet gevonden');

    const fragment = document.createElement('div');
    fragment.className = 'footer-info-modal__fetched-content';
    Array.from(main.children).forEach((child) => fragment.appendChild(document.importNode(child, true)));
    return cleanFetchedContent(fragment);
  };

  const openModal = async (link) => {
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) {
      window.location.assign(link.href);
      return;
    }

    returnFocus = link;
    title.textContent = link.textContent.trim() || 'Informatie';
    modal.hidden = false;
    document.body.classList.add('footer-info-modal-open');
    setLoading(true);
    panel.focus();

    try {
      requestController?.abort();
      requestController = new AbortController();

      let fragment;
      if (cache.has(url.href)) {
        fragment = cache.get(url.href).cloneNode(true);
      } else {
        const response = await fetch(url.href, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: requestController.signal
        });
        if (!response.ok) throw new Error(`Pagina kon niet worden geladen (${response.status})`);
        fragment = extractContent(await response.text());
        cache.set(url.href, fragment.cloneNode(true));
      }

      body.replaceChildren(fragment);
      setLoading(false);
      window.LuxorInitFaq?.(body);
      window.LuxorWishlistRefresh?.();
      body.scrollTop = 0;
    } catch (error) {
      if (error.name === 'AbortError') return;
      closeModal();
      window.location.assign(url.href);
    } finally {
      requestController = null;
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-footer-popup-link]');
    if (!link) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openModal(link);
  });

  modal.querySelectorAll('[data-footer-info-modal-close]').forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });
})();
